import { short_sha256 } from '@/utils'

export function get_email_from_queries(canonical, queries) {
  let email = null
  if (queries.ee) {
    try {
      email = atob(queries.ee)
      if (canonical !== null && hash(canonical, email) !== queries.th) {
        email = null
      }
    }
    catch (e) {
    }
  }
  else if (queries.email) {
    email = queries.email
  }
  return email
}

export function generate_tracking_params(canonical, email) {
  const th = hash(canonical, email)
  const ee = btoa(email)
  return { th, ee }
}

function hash(canonical, email) {
  return short_sha256(`${canonical}|${email}`)
}
